/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SNFSStripeGroup,
    SNFSStripeGroupFromJSON,
    SNFSStripeGroupFromJSONTyped,
    SNFSStripeGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface VolumeSNFSStatus
 */
export interface VolumeSNFSStatus {
    /**
     * 
     * @type {Array<SNFSStripeGroup>}
     * @memberof VolumeSNFSStatus
     */
    stripeGroups: Array<SNFSStripeGroup>;
}

export function VolumeSNFSStatusFromJSON(json: any): VolumeSNFSStatus {
    return VolumeSNFSStatusFromJSONTyped(json, false);
}

export function VolumeSNFSStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeSNFSStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stripeGroups': ((json['stripe_groups'] as Array<any>).map(SNFSStripeGroupFromJSON)),
    };
}

export function VolumeSNFSStatusToJSON(value?: VolumeSNFSStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stripe_groups': ((value.stripeGroups as Array<any>).map(SNFSStripeGroupToJSON)),
    };
}


